import React, {useEffect, useState, useRef} from "react";
import {useDispatch} from "react-redux";
import {Link} from "react-router-dom";
import {toast} from "react-toastify";
import InputField from "../../components/InputField/InputField";
import Config from "../../Config";
import {login, getMe, LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS, SET_BIG_COMMERCE_URL, SET_TOKEN} from "../../store/actions";
import useQuery from "../../hooks/useQuery";
import {HOSTS, REGIONS} from "../../utils/constants";
import {fetchUtil} from "../../helpers/fetchUtil";
import ForgotPassword from "../../components/ForgotPassword/ForgotPassword";

const LoginForm = ({t}) => {
    const dispatch = useDispatch()
    const query = useQuery()

    const [loginData, setLoginData] = useState({
        email: "",
        password: "",
        bigCommerceLoginUrl: "",
        ip: null,
        region: query.get("region")?.toLowerCase() || "us"
    })
    const [isLoading, setIsLoading] = useState(false)


    const getIpfy = () => {
        fetch('https://api.ipify.org/?format=json')
          .then(response => response.json())
          .then(data => {
            console.log('Your public IP address is: ' + data.ip);
              setLoginData({...loginData, ip:  data.ip});

          })
          .catch(error => {
              console.log("Tracking IP error", error)
          });

    };

    // Add component mounted state to prevent state updates after unmounting
    const isMountedRef = useRef(true);
    
    useEffect(() => {
        getIpfy();
        
        // Cleanup function to handle unmounting
        return () => {
            isMountedRef.current = false;
        };
    }, []);


    const handleSubmit = () => {
        const {email, password, region, ip } = loginData;
        const referrer = query.get("referrer")

        if (!email || !password) {
            toast.error(t("form_fields_are_required"));
            return false;
        }
        setIsLoading(true);
        
        // Use the Redux login action that is now properly imported at the top
        
        login(email, password, region)(dispatch)
            .then((response) => {
                // Only update state if the component is still mounted
                if (isMountedRef.current) {
                    console.log("Login success:", response);
                    
                    // Check for multipassUrl in the response
                    if (response.multipassUrl) {
                        setLoginData({...loginData, bigCommerceLoginUrl: response.multipassUrl});
                    }
                    
                    // Redirect if needed
                    if (referrer === "bigcommerce" && response.multipassUrl) {
                        setTimeout(() => {
                            if (document.getElementById("btn-redirect")) {
                                document.getElementById("btn-redirect").click();
                            }
                        }, 500);
                    }
                    
                    localStorage.isAuthenticated = true;
                    return Promise.resolve(response);
                }
            })
            .catch((error) => {
                // Only update state if the component is still mounted
                if (isMountedRef.current) {
                    console.log("LOGIN ERROR:", error.message || error);
                    toast.error(error.message || "Login failed");
                    setIsLoading(false);
                }
            })
            .finally(() => {
                if (isMountedRef.current) {
                    setIsLoading(false);
                }
            });

    };

    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            handleSubmit();
        }
    };

    const handleChange = (evt) => {
        setLoginData({...loginData, [evt.target.name]: evt.target.value});
    };

    return (
        <>
            <a id="btn-redirect" href={loginData?.bigCommerceLoginUrl} target="_blank" rel="noopener noreferrer"></a>
            <div className="login__field pt-5">
                <InputField
                    type="email"
                    placeholder={"email"}
                    name="email"
                    secure={false}
                    onChange={handleChange}
                    value={loginData?.email}
                    onKeyPress={handleKeypress}
                />
                <InputField
                    type="password"
                    placeholder={"password"}
                    name="password"
                    secure={true}
                    onChange={handleChange}
                    value={loginData?.password}
                    onKeyPress={handleKeypress}
                />

                <div className="region-select">
                    <select
                        id={"region"}
                        name="region"
                        className="bg-transparent input-feild"
                        style={{
                            width: "100%",
                            height: 50,
                            margin: 0,
                            padding: "0px 10px",
                            color: "rgb(255, 255, 255)",
                            border: "1px solid rgb(255, 255, 255)",
                        }}
                        onChange={handleChange}
                        value={loginData?.region}
                    >
                        <option style={{background: "#332d3b"}} value="">{t("region")}</option>
                        {REGIONS.map((region, index) => {
                            return (
                                <option style={{background: "#332d3b"}} value={region.value} key={index}>
                                    {region.label}
                                </option>
                            );
                        })}
                    </select>
                </div>

                <button
                    onClick={handleSubmit}
                    className="btn btn-primary mt-4"
                >
                    {isLoading ? (
                        <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    ) : (
                        t("login")
                    )}
                </button>

                <Link to={`/signup?region=${loginData?.region}`} >
                    <a className="d-block text-center pt-3 btn-link">
                        {t("create_Account")}
                    </a>
                </Link>

                <div style={{textAlign: 'center', marginTop: 20}}>
                    <ForgotPassword />
                </div>
            </div>
        </>
    )
}

export default LoginForm